/**
 * @file snack-bar.component.tsx
 * @description Компонент для отображения списка ошибок. Используется библиотека @consta/uikit/SnackBar.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies []
 * @related-files []
 */

import { SnackBar as ConstaSnackBar } from '@consta/uikit/SnackBar';
import { Button } from '@consta/uikit/Button';
import cn from 'classnames';
import Markdown from 'react-markdown';
import { TErrorMessage } from '@src/types';
import { IconClose } from '@consta/icons/IconClose';
import { DangerStatusIcon, WarningStatusIcon } from './icons';

/**
 * Props для компонента SnackBar (уведомлений об ошибках)
 */
interface ISnackBarProps {
    /** Массив сообщений об ошибках для отображения */
    items: TErrorMessage[];
    /** Функция для управления элементами списка ошибок */
    setItems: (newItemsList: TErrorMessage[]) => void;
    /** Функция для очистки всех элементов списка */
    clearItems: () => void;
}

export const SnackBar = ({ items, setItems, clearItems }: ISnackBarProps) => {
    return (
        <>
            <ConstaSnackBar
                items={items}
                className={cn({ 'mb-[5.7905vmin]': items.length > 1, hidden: !items.length })}
                getItemMessage={(item: TErrorMessage) => {
                    return (
                        <div className="snackBar__message-card w-full flex flex-col gap-[0.8468vmin]">
                            <div className="snackBar__message-card-title flex justify-between items-center">
                                <div className="flex gap-[1.0585vmin] items-center">
                                    {getCardIconByStatus(item.status)}

                                    <div className="text-[1.482vmin] font-medium leading-[120%]">{item.title}</div>
                                </div>

                                <IconClose
                                    size="s"
                                    className="snackBar__message-card_close cursor-pointer"
                                    onClick={() => setItems(items.filter((snack) => snack.key !== item.key))}
                                />
                            </div>

                            <hr className="border-[#4D7C99]" />

                            <Markdown className="text-[1.3761vmin] font-normal leading-[120%]">{item.message}</Markdown>
                        </div>
                    );
                }}
                getItemAutoClose={() => 400}
            />

            {items.length > 1 && (
                <Button
                    label="Закрыть все"
                    view="secondary"
                    className="snackBarItems__close-all absolute right-0 bottom-0 mr-[0.8468vmin] mb-[0.8468vmin]"
                    onClick={() => clearItems()}
                />
            )}
        </>
    );
};

const getCardIconByStatus = (status: 'danger' | 'warning' | 'info' | undefined) => {
    switch (status) {
        case 'warning':
            return <WarningStatusIcon />;
        case 'danger':
            return <DangerStatusIcon />;
        default:
            return null;
    }
};
